import React from 'react';
import {
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';
import styled from 'styled-components';

const InlineDropdown = styled(UncontrolledDropdown)`
  display: inline-block;
`;

export default class RequiredFileFormatSelector extends React.Component {
  constructor(props) {
    super(props);
  }

  calculateOptions(state) {
    let pageOptions = [];
    if (state.bepFlag)
      pageOptions.push({
        id: 'Fixed Income Required Fields',
        path: '/field-spec/bonds',
      });
    if (state.fepSpotFlag)
      pageOptions.push({
        id: 'FX Spot Required Fields',
        path: '/field-spec/spot',
      });
    if (state.fepForwardsFlag)
      pageOptions.push({
        id: 'FX Forward Required Fields',
        path: '/field-spec/forwards',
      });
    if (state.repLinearFlag)
      pageOptions.push({
        id: 'Interest Rate Swaps Required Fields',
        path: '/field-spec/irs',
      });
    if (state.fepNonLinearFlag)
      pageOptions.push({
        id: 'Options Required Fields',
        path: '/field-spec/options',
      });
    return pageOptions;
  }

  render() {
    return (
      <InlineDropdown className={this.props.className} direction="right">
        <DropdownToggle color="default" outline>
          View Required File Format
        </DropdownToggle>
        <DropdownMenu aria-labelledby="navbarDropdownMenuLink">
          {' '}
          {this.calculateOptions(this.props).map((page) => (
            <DropdownItem key={page.id} value={page.id} href={page.path}>
              {page.id}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </InlineDropdown>
    );
  }
}
